import { Button, Icon, Loader, Modal, ModalConfirm, t } from "owc-react-lib-common";
import React from "react";
import { Container } from "src/components/Container";
import { IconLink } from "src/components/IconLink";
import { Table } from "src/components/Table";
import { Text } from "src/components/Text";
import { useAlerts } from "src/hooks/useAlerts";
import { useComponentDidMount } from "src/hooks/useComponentDidMount";
import * as CompetitionSchemeService from "src/services/CompetitionSchemeService";
import { StepperSchema } from "./StepperSchema";

export const SchemaList = () => {
  const alerts = useAlerts();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [data, setData] = React.useState<any[]>([]);
  const [selectedSchema, setSelectedSchema] = React.useState<any>(null);
  const [deleteSchema, setDeleteSchema] = React.useState<any>(null);
  const [deleteModalVisible, setDeleteModalVisible] = React.useState<boolean>(false);


  const fetchData = async () => {
  try {
    const response = await CompetitionSchemeService.getAllScheme();
    setData(response.data);
    setLoading(false);
  } catch (error) {
    alerts.createDSMError(error);
  }
};

  useComponentDidMount(() => {
    fetchData();
  });

  /* create */
  const handleCreateSchema = () => {
    setSelectedSchema({ });  
  };


  /* delete */
  const handleDeleteSchema = async () => {
    try {
      await CompetitionSchemeService.deleteScheme(deleteSchema);
      setData((prevData) => prevData.filter((schema) => schema.id !== deleteSchema.id));

      alerts.create({ text: t("admin.schema.schemaList.deleted"), type: "success" });
      setDeleteModalVisible(false);
      setDeleteSchema(null);
    } catch (error) {
      alerts.createDSMError(error);
    }
  };
  const headers = [
    { name: "id", label: t("admin.schema.schemaList.id"), width: 50 },
    { name: "name", label: t("admin.schema.schemaList.name"), width: 300 },
    {
      name: "groups",
      label: t("admin.schema.schemaList.groups"),
      render: (row: any) => (
        <ul>
          {row.groups?.map((group, index) => (
            <li key={index}>
              <Text bold>{group.groupName}: </Text> <Text>{group.numTeams} {t("admin.schema.schemaList.numTeams")} | </Text>  
              <Text> {group.numRounds} {t("admin.schema.schemaList.numRounds")}</Text>
            </li>
          ))}
        </ul>
      ),
    },
    {
      name: "actions",
      label: '',
      render: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
            <IconLink
                backgroundColor="transparent"
                color="black"
                name={"eye"}
                title={t('global.view')}
                to={`/organizer/schema/${row.id}`}
            />
          <Icon
            type="trash"
            onPress={() => {
              setDeleteSchema(row);
              setDeleteModalVisible(true);
            }}
          />
        </div>
      ),
      width: 150,
    },
  ];

  if (loading) {
    return <Loader />;
  }

  return (
    <Container title={t("admin.schema.schemaList.title")}>
      <Button text={t("admin.schema.schemaList.create")} onPress={handleCreateSchema} />
      <Table headers={headers} data={data} />

      {/* Modal for creating or editing a schema */}
      {selectedSchema && (
        <Modal visible title={selectedSchema?.name ?? t("organizer.schema.create")} fullscreen close={() => setSelectedSchema(undefined)}>
          <StepperSchema
            schema={selectedSchema}
            onClose={async () => {
              await fetchData(); // Recargar la lista de esquemas
              setSelectedSchema(undefined); // Cerrar el modal
            }}
          />
        </Modal>
      )}

      <ModalConfirm
        visible={deleteModalVisible}
        text={t("admin.schema.schemaList.deleteconfirmation")}
        accept={handleDeleteSchema}
        close={() => setDeleteModalVisible(false)}
      />


    </Container>
  );
};